// app/(main)/categories/page.tsx
import { categoryService, sectorService } from '@cabukaka/services';
import { useEffect, useState } from 'react';
import { PageContainer } from '../../../components/ui/PageContainer';
import Hero from '../../../components/sections/categories/Hero';
import CategoriesBySector from '../../../components/sections/categories/CategoriesBySector';
import PageHead from '../../../components/ui/PageHead';
import { Category, Sector } from '@cabukaka/types';

export default function CategoriesPage() {
    const [categories, setCategories] = useState<Category[]>([]);
    const [sectors, setSectors] = useState<Sector[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoriesData, sectorsData] = await Promise.all([
                    categoryService.getCategories(),
                    sectorService.getSectors()
                ]);
                setCategories(categoriesData?.data || []);
                setSectors(sectorsData?.data || []);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <PageContainer className="min-h-screen bg-white">
                <div className="flex items-center justify-center min-h-[60vh]">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
                </div>
            </PageContainer>
        );
    }

    return (
        <>
            <PageHead 
                title="Toutes les catégories | Cabukaka"
                description="Découvrez toutes nos catégories de produits au Cameroun. Trouvez ce que vous cherchez parmi des milliers de produits."
            />

            <PageContainer className="min-h-screen bg-white">
                <Hero />

                <div className="h-12 md:h-16" />

                <CategoriesBySector sectors={sectors} categories={categories} />
            </PageContainer>
        </>
    );
}